// extracted by mini-css-extract-plugin
export default {"smBreak":"600px","unit":"8px","quickSearchRoot":"jxnu0OgEwBNwiJut7ReV","input":"_50BF2FlZ8JJiwqreYUHr"};